export default {"src":"/_next/static/media/geography.4af1d077.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};